import { css } from '@emotion/react';

export const textfields = css`
  margin: 16px 0 0 !important;
`;
